import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";

import { filesByProjectId } from "../../api";
import { fileDownload } from "../../api/file";
import { Document, DownloadCloud } from "../../assets/icons";
import {
  FileList,
  OrderCard,
  OrderHeaderCard,
  TableList
} from "../../components";
import styles from "../../components/Layout/Layout.module.scss";
import { useApi } from "../../context/context";
import {
  cipDateFormat,
  getOrderDates,
  getOrderStatus,
  getOrderType
} from "../../utils";

function ProjectPage() {
  // console.count("Project Render count");
  const { t } = useTranslation();
  const { projectId } = useParams();

  const { getProjectByProjectId, documents, user } = useApi();

  const [project, setProject] = useState(getProjectByProjectId(projectId));
  const [projectDocuments, setProjectDocuments] = useState([]);

  // console.log("project", project);

  useEffect(() => {
    if (projectId) {
      setProject(getProjectByProjectId(projectId));
    }
  }, [getProjectByProjectId, projectId]);

  const fetchDocuments = async (orders) => {
    const documentList = await documents(orders, projectId);
    const filesList = await filesByProjectId(projectId, user?.token);

    const modifiedDocumentsList = documentList.map((file) => {
      return {
        ...file,
        file: file.FullName,
        Url: `Transport_pod/pod-${file.OrderID}.pdf`,
        columns: {
          type: "Signature",
          order: file.OrderID > 0 ? file.OrderID : ""
        }
      };
    });

    const modifiedfilesList = filesList.map((file) => {
      return {
        ...file,
        file: file.FileNameOrg,
        Url: file.FilenameSaved,
        columns: {
          type: file.Type,
          order: file.OrderID > 0 ? file.OrderID : ""
        }
      };
    });

    setProjectDocuments([...modifiedDocumentsList, ...modifiedfilesList]);
  };

  useEffect(() => {
    if (project) {
      const { orders } = project;
      // async func
      const fetchDocumentsLocally = async () => {
        const documentList = await documents(orders, projectId);
        const filesList = await filesByProjectId(projectId, user?.token);

        const modifiedDocumentsList = documentList.map((file) => {
          return {
            ...file,
            file: file.FullName,
            Url: `Transport_pod/pod-${file.OrderID}.pdf`,
            columns: {
              type: "Signature",
              order: file.OrderID > 0 ? file.OrderID : ""
            }
          };
        });
        const modifiedfilesList = filesList.map((file) => {
          return {
            ...file,
            file: file.FileNameOrg,
            Url: file.FilenameSaved,
            columns: {
              type: file.Type,
              order: file.OrderID > 0 ? file.OrderID : ""
            }
          };
        });
        setProjectDocuments([...modifiedDocumentsList, ...modifiedfilesList]);
      };

      // run
      fetchDocumentsLocally();
    }
  }, [documents, project, projectId, user?.token]);

  if (!project) {
    return (
      <>
        <h1>No projects found</h1>
      </>
    );
  }

  const { orders, Header, ProjectID, invoices } = project;
  // console.log("orders", orders);
  // console.log("docs", projectDocuments);
  return (
    <>
      <Link className="back-button" to="/projects">
        {t("back")}
      </Link>
      <span className="sub-heading">
        {t("project")} {projectId}
      </span>
      <Typography variant="h1" color="primary.main">
        {Header || ProjectID}
      </Typography>
      <ul>
        <li>
          <OrderHeaderCard />
        </li>
        {orders
          ?.filter((a) => a?.OrderStatus[0]?.StatusNo !== 0)
          .map((order, i) => {
            // TODO: Above filter is QUICK FIX to remove orders with StatusNo == 0
            // console.log("single order", order);
            const {
              Header: orderHeader,
              OrderID,
              DeliveryAdress,
              DeliveryCity,
              PickupAdress,
              PickupCity,
              OrderStatus = [{}] //  [{}] array of status objects
            } = order;

            const { startDate, endDate, pickupTime, deliveryTime } =
              getOrderDates(order);

            const firstOrder =
              OrderStatus && OrderStatus.length > 0 ? OrderStatus[0] : {};

            const {
              PickupWantedTimeFlag = null,
              DeliveryWantedTimeFlag = null
            } = firstOrder;
            // console.log("order", order);
            // console.log("order.OrderStatus", order.OrderStatus);
            // console.log(OrderID, order);
            // const fakeOrder = {
            //   OrderStatus: [{ StatusNo: 319 }]
            // };
            return (
              <li key={order.OrderID}>
                <Link to={`/order/${OrderID}`}>
                  <OrderCard
                    Header={orderHeader}
                    OrderStatus={OrderStatus}
                    ongoingOrder={getOrderStatus(order)}
                    orderId={OrderID}
                    to={{
                      address: DeliveryAdress,
                      city: DeliveryCity
                    }}
                    from={{
                      address: PickupAdress,
                      city: PickupCity
                    }}
                    orderType={getOrderType(order)}
                    startDate={startDate}
                    endDate={endDate}
                    pickupTime={pickupTime}
                    deliveryTime={deliveryTime}
                    PickupWantedTimeFlag={PickupWantedTimeFlag}
                    DeliveryWantedTimeFlag={DeliveryWantedTimeFlag}
                    first={i < 1}
                    last={i === orders?.length - 1}
                  />
                </Link>
              </li>
            );
          })}
      </ul>
      <div className={styles.docListContainer}>
        <div>
          <h2>{t("documents")}</h2>
          <FileList
            project={project}
            orders={orders}
            list={projectDocuments}
            updateFileList={() => {
              console.debug("running callback");
              fetchDocuments(orders);
            }}
            canUpload={true}
          />
        </div>
        <div>
          <h2>{t("invoices")}</h2>
          <TableList
            data={invoices}
            canUpload={false}
            columns={[
              {
                name: "InvoiceNumber",
                title: "#",
                modifier: (v) => (
                  <>
                    <span className="td-icon">
                      <Document />
                    </span>{" "}
                    {v}
                  </>
                )
              },
              {
                name: "InvoiceDate",
                title: t("date"),
                modifier: cipDateFormat
              },
              {
                name: "Description",
                title: t("description"),
                modifier: (v) => <strong>{v}</strong>
              },
              {
                name: "InvoiceNumber",
                title: "Download",
                modifier: (v) => (
                  <a
                    target="_blank"
                    download
                    href={fileDownload(
                      "Invoices/invoice-" + v + ".pdf",
                      "external",
                      "invoice-" + v + ".pdf"
                    )}
                    style={{ paddingRight: "10px" }}
                    rel="noreferrer"
                  >
                    <DownloadCloud />
                  </a>
                )
              }
            ]}
          />
        </div>
      </div>
    </>
  );
}

export default ProjectPage;
